export enum Weekdays {
    None = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 4,
    Thursday = 8,
    Friday = 16,
    Saturday = 32,
    Sunday = 64
}

export class WeekdayHelper {
    public static ConvertToEnum(value: any): Weekdays {
        let weekday = Weekdays.None;

        if (typeof value === 'string') {
            let values = value.split(',');
            values.forEach(v => weekday |= Weekdays[v]);
        }

        return weekday;
    }

    public static ConvertFromEnumToStringValues(weekdays: Weekdays): string {
        var list: string[] = [];
        if (weekdays & Weekdays.Monday) {
            list.push('Monday');
        }
        if (weekdays & Weekdays.Tuesday) {
            list.push('Tuesday');
        }
        if (weekdays & Weekdays.Wednesday) {
            list.push('Wednesday');
        }
        if (weekdays & Weekdays.Thursday) {
            list.push('Thursday');
        }
        if (weekdays & Weekdays.Friday) {
            list.push('Friday');
        }
        if (weekdays & Weekdays.Saturday) {
            list.push('Saturday');
        }
        if (weekdays & Weekdays.Sunday) {
            list.push('Sunday');
        }

        return list.join(',');
    }
}